import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "inline-label-edit",
  templateUrl: "./inline-label-edit.component.html",
})
export class InlineLabelEditComponent implements OnInit {

  @Input() public label: string;
  @Output() public update = new EventEmitter();

  public isEditing: boolean = false;
  public tempLabel: string = "";

  public ngOnInit(): void {
    this.tempLabel = this.label;
  }

  public enableEdit() {
    if (this.isEditing === false) {
      this.isEditing = true;
    }
  }

  public save(e) {
    e.stopPropagation();
    this.isEditing = false;
    this.update.emit(this.tempLabel);
  }

  public cancel(e) {
    e.stopPropagation();
    this.tempLabel = this.label;
    this.isEditing = false;
  }

}
